/** Pixel dimensions of a data URL — used to convert a normalized (0..1)
 *  crop rect into the integer pixel offsets the backend's crop renderer
 *  expects (see `host-listing-draft.service.ts`'s `syncDraftPhotos`). */
export function measureDataUrl(dataUrl: string): Promise<{ width: number; height: number }> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve({ width: img.naturalWidth, height: img.naturalHeight });
    img.onerror = () => reject(new Error('Failed to measure image'));
    img.src = dataUrl;
  });
}
